import React from 'react';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';

function styles() {
  return {
    '@keyframes sfLogoOut': {
      from: { opacity: 1, transform: 'scale(1) translateY(0)' },
      to: { opacity: 0, transform: 'scale(0.96) translateY(-4px)' },
    },
    '@keyframes sfPulse': {
      '0%': { opacity: 0.92, transform: 'scale(1)' },
      '50%': { opacity: 1, transform: 'scale(1.025)' },
      '100%': { opacity: 0.92, transform: 'scale(1)' },
    },
    '@keyframes sfCaptionSwap': {
      '0%': { opacity: 1, transform: 'translateY(0)' },
      '40%': { opacity: 0, transform: 'translateY(-3px)' },
      '60%': { opacity: 0, transform: 'translateY(3px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' },
    },
    '@keyframes sfBarSlide': {
      '0%': { left: '-40%', width: '40%' },
      '50%': { left: '30%', width: '50%' },
      '100%': { left: '100%', width: '40%' },
    },
    stage: {
      position: 'fixed',
      inset: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: `
        radial-gradient(ellipse at 20% 15%, rgba(9, 175, 223, 0.35), transparent 55%),
        radial-gradient(ellipse at 85% 88%, rgba(0, 128, 173, 0.30), transparent 55%),
        linear-gradient(160deg, #b6d8e3 0%, #d8ecf2 50%, #a8cfdc 100%)
      `,
      overflow: 'hidden',
      zIndex: 9999,
    },
    // Sem animação de entrada — o logo já vem visível do HTML inline
    // (.sf-boot em apps/*/index.html). Animar do zero aqui causava um
    // "soluço" quando o React substituía o boot estático.
    logoWrap: {
      position: 'relative',
      animation: '$sfPulse 2.4s ease-in-out infinite',
    },
    logoOut: {
      animation: '$sfLogoOut 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards',
    },
    logo: {
      width: 280,
      maxWidth: '60vw',
      height: 'auto',
      display: 'block',
      userSelect: 'none',
      filter: 'drop-shadow(0 10px 28px rgba(0, 128, 173, 0.22))',
    },
    progressWrap: {
      marginTop: 48,
      width: 220,
      height: 3,
      borderRadius: 999,
      backgroundColor: 'rgba(0, 128, 173, 0.14)',
      overflow: 'hidden',
      position: 'relative',
    },
    progressBar: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      borderRadius: 999,
      background: 'linear-gradient(90deg, #09AFDF 0%, #0080ad 100%)',
      animation: '$sfBarSlide 1.6s cubic-bezier(0.45, 0, 0.55, 1) infinite',
    },
    caption: {
      marginTop: 18,
      fontFamily: '"Montserrat", system-ui, sans-serif',
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: '1.4px',
      textTransform: 'uppercase',
      color: 'rgba(25, 121, 151, 0.75)',
    },
    captionSwap: {
      animation: '$sfCaptionSwap 0.45s ease forwards',
    },
  };
}

function OpeningAnimation(props) {
  const { reverse, farewell, classes } = props;
  const captionText = farewell ? 'Pronto, vamos iniciar!' : 'Preparando sua plataforma';

  return (
    <div className={classes.stage}>
      <div className={classNames(classes.logoWrap, reverse && classes.logoOut)}>
        <img alt="Sua Formatura" className={classes.logo} src="/img/logotipo.svg" />
      </div>
      {!reverse && (
        <>
          <div className={classes.progressWrap}>
            <div className={classes.progressBar} />
          </div>
          <div
            key={captionText}
            className={classNames(classes.caption, farewell && classes.captionSwap)}
          >
            {captionText}
          </div>
        </>
      )}
    </div>
  );
}

export default withStyles(styles)(OpeningAnimation);
